import React from 'react';
import { Headset, PhoneIncoming, PhoneOutgoing } from 'lucide-react';
import { Chip } from 'common/components';
import type { CallStatistic } from 'types/call.type';
import { formatChipPercent, formatCount } from '../../callStatusSummary.utils';

export type CallDirectionChipsProps = {
    callStats?: CallStatistic;
    filteredTotal: number;
};

export const CallDirectionChips: React.FC<CallDirectionChipsProps> = ({ callStats, filteredTotal }) => (
    <div className='flex gap-sm flex-wrap'>
        <Chip variant='outlined' color='secondary' corner='pill'>
            <div className='flex items-center gap-sm'>
                <PhoneOutgoing size={10} color='var(--primary-purple)' />
                <span className='text-sm font-semibold text-black'>
                    Outbound {formatCount(callStats?.outbound ?? 0)}
                </span>
                <span className='text-sm'>({formatChipPercent(callStats?.outbound ?? 0, filteredTotal)})</span>
            </div>
        </Chip>
        <Chip variant='outlined' color='secondary' corner='pill'>
            <div className='flex items-center gap-sm'>
                <PhoneIncoming size={10} color='var(--primary-purple)' />
                <span className='text-sm font-semibold text-black'>Inbound {formatCount(callStats?.inbound ?? 0)}</span>
                <span className='text-sm'>({formatChipPercent(callStats?.inbound ?? 0, filteredTotal)})</span>
            </div>
        </Chip>
        <Chip variant='outlined' color='secondary' corner='pill'>
            <div className='flex items-center gap-sm'>
                <Headset size={10} color='var(--primary-purple)' />
                <span className='text-sm font-semibold text-black'>Manual {formatCount(callStats?.manual ?? 0)}</span>
                <span className='text-sm'>({formatChipPercent(callStats?.manual ?? 0, filteredTotal)})</span>
            </div>
        </Chip>
    </div>
);
